import React, { useEffect, useState, useContext, useRef } from 'react';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from "moment-jalali";
import ReactSelect from 'react-select';

import { useEntityCrud } from '../../hooks/useEntityCrud';
import InputMask from 'react-input-mask';
import { Context } from '../../context/UserContext';
import { toast } from 'react-toastify';
import Pagination from '../Common/Pagination';
import { Link, useSearchParams } from 'react-router-dom';
import * as SignalR from '@microsoft/signalr';

const Index = ({ isEditMode }) => {


    const { readData } = useEntityCrud('Report/getTransactions');
    const { readData: getBusiness } = useEntityCrud('Business/GetAllBusiness');
    const { readData: getBranches } = useEntityCrud('Branch/GetAllBranchs');
    const roleId = localStorage.getItem('rl');
    const [searchParams, setSearchParams] = useSearchParams()

    const context = useContext(Context);
    const { readData: GetAllServiceConsumer } = useEntityCrud('ServiceConsumer/GetServiceConsumerDetail');
    const [rows, setRows] = useState();
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const [filterItems, setFilterItems] = useState({ p_nationalno: searchParams.get('nationalCode') || '' });
    const [data, setData] = useState([]);
    const [cardSave, setCardSave] = useState("")

    const [pan, setPan] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [consumerNationalCode, setConsumerNationalCode] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const [fromMinDate,setFromMinDate] = useState()
    const [toMinDate,setToMinDate] = useState()
    const [fromMaxDate,setFromMaxDate] = useState()
    const [toMaxDate,setToMaxDate] = useState()

    const btnRef = useRef();
    const collapseBoxRef = useRef();

    const [issueDate, setIssueDate] = useState(null);
    const [expireDate, setExpireDate] = useState(null);

    const [advancedSearch, setAdvancedSearch] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [showNotData, setShowNotData] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    const [branches, setBranches] = useState([]);

    const [businesses, setBusinesses] = useState([]);
    const [businessId, setBusinessId] = useState(0);
    const [showItem, setShowItem] = useState(true);

    const businessIds = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))?.businessId : []

    const [pageItems, setPageItems] = useState(9);
    const [count, setCount] = useState(0);


    useEffect(() => {
        debugger
        showMore(pageItems)
    }, [pageItems])

    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, 'jYYYY/jMM/jDD').format('jYYYY/jMM/jDD');
    }

    const getDateObj = date => {
        return {
            year: parseInt(date[0]),
            month: parseInt(date[1]),
            day: parseInt(date[2])
        }
    }

    useEffect(() => {
        const today = moment().format('jYYYY/jMM/jDD').split('/');
        const todayObj = getDateObj(today)
        setFromMaxDate(todayObj)
        setToMaxDate(todayObj)
    },[])

    useEffect(() => {
        if(issueDate){
            const selectedDate = moment(`${issueDate.year}/${issueDate.month}/${issueDate.day}`, 'jYYYY/jMM/jDD').add(3,'months').format('jYYYY/jMM/jDD').split('/');
            const selectedMinDate = moment(`${issueDate.year}/${issueDate.month}/${issueDate.day}`, 'jYYYY/jMM/jDD').format('jYYYY/jMM/jDD').split('/');
            const selectedDateObj = getDateObj(selectedDate);
            const selectedMinDateObj = getDateObj(selectedMinDate);
            setToMaxDate(selectedDateObj);
            setToMinDate(selectedMinDateObj);
        }else{
            const today = moment().format('jYYYY/jMM/jDD').split('/');
            const todayObj = getDateObj(today)
            setToMaxDate(todayObj);
            setToMinDate(null);
        }
    },[issueDate])

    useEffect(() => {
        if(expireDate){
            const selectedDate = moment(`${expireDate.year}/${expireDate.month}/${expireDate.day}`, 'jYYYY/jMM/jDD').subtract(3,'months').format('jYYYY/jMM/jDD').split('/');
            const selectedMaxDate = moment(`${expireDate.year}/${expireDate.month}/${expireDate.day}`, 'jYYYY/jMM/jDD').format('jYYYY/jMM/jDD').split('/');
            const selectedDateObj = getDateObj(selectedDate);
            const selectedMaxDateObj = getDateObj(selectedMaxDate);
            setFromMinDate(selectedDateObj);
            setFromMaxDate(selectedMaxDateObj)
        }else{
            const today = moment().format('jYYYY/jMM/jDD').split('/');
            const todayObj = getDateObj(today)
            setFromMinDate(null);
            setFromMaxDate(todayObj);
        }
    },[expireDate])

    const showMore = (val) => {
        debugger
        const postedData = {
            "p_card": filterItems.p_cardno || "",
            "p_fromdate": (convertToDate(issueDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_todate": (convertToDate(expireDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_businessid": businessId || businessIds ? (businessId ? businessId : businessIds).toString() : 0,
            "p_mobile": filterItems.p_mobileno || "",
            "p_nationalcode": filterItems.p_nationalno || (searchParams.get('nationalCode') || ''),
            "p_status": parseInt(filterItems?.p_status) || 0,
            "p_offset": currentPage,
            "p_limit": val,
            "p_rrn": filterItems.p_rrn || "",
            "p_traceno": filterItems.p_traceno || "",
            // "p_companyid": filterItems.p_companyid || ""
        }
        if(filterItems.p_companyid)
            postedData.p_companyid = filterItems.p_companyid;
        if (filterItems.p_channel)
            postedData.p_channel = filterItems.p_channel;
        setLoading(true)
        readData(postedData).then(({ data }) => {
            debugger
            setLoading(false)
            if (data?.result?.v_count[0]?.cnt_total === null) setShowNotData(true)
            setData(data?.result?.v_result)
            calcPages(data?.result?.v_count[0]?.cnt_total);
            setShowItem(true);
            setCount(data.result.v_count[0].cnt_total);

        });
    }



    useEffect(() => {
        const postedData = {
            fromdate: convertToDate(fromDate) || convertToDate(getToday()),
            todate: convertToDate(toDate) || convertToDate(getToday()),

        };
        getData(postedData);
    }, [fromDate, toDate])




    useEffect(() => {

        getBusiness().then(({ data }) => {
            let businesses = [];
            if (data.status)
                data.result.map(item => {
                    // if (item.isActive) {
                        if (!(businesses?.find(it => it.label === item.title))) {
                            businesses.push({
                                label: item.title,
                                value: item.id
                            });
                        }
                    // }
                })
            setBusinesses(businesses);
        });
        getBranches().then(({ data }) => {
            let branchesData = [];
            if(data.status){
                data.result.map(item => {
                    if(item.isActive)
                        branchesData.push({
                            label: item.title,
                            value: item.id
                        })
                })
            }
            setBranches(branchesData);
        })
    }, [])


    const getDataServiceConsumer = (searchData) => {
        debugger
        setShowLoading(true);
        const postedData = {
            offset: currentPage,
            limit: (pageItems === 0 ? 9 : pageItems),
            ...searchData
        };
        GetAllServiceConsumer(postedData).then(res => {
            debugger
            if (res.data.status) {
                calcPages(res);
                setRows(res.data.result);
            } else {
                setRows();
                setPages([]);
                toast.error(res.data.message)
            }
            setShowLoading(false);
        }).finally(() => {
            setShowLoading(false);
        })
    }



    const getData = (otherPostedData = {}, filteredPostedData = {}) => {
        setCardSave(filterItems.p_cardno)
        debugger
        const postedData = {
            "p_card": filterItems.p_cardno || "",
            "p_fromdate": (convertToDate(issueDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_todate": (convertToDate(expireDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_businessid": businessId || businessIds ? (businessId ? businessId : businessIds).toString() : 0,
            // "p_businessid": "511",
            "p_mobile": filterItems.p_mobileno || "",
            "p_nationalcode": filterItems.p_nationalno || (searchParams.get('nationalCode') || ''),
            "p_status": parseInt(filterItems?.p_status) || 0,
            "p_offset": currentPage,
            "p_limit": pageItems === 0 ? 9 : pageItems,
            "p_rrn": filterItems.p_rrn || "",
            "p_traceno": filterItems.p_traceno || "",
            // "p_companyid": filterItems.p_companyid || ""
        }
        if(filterItems.p_companyid)
            postedData.p_companyid = filterItems.p_companyid;
        if (filterItems.p_channel)
            postedData.p_channel = filterItems.p_channel;
        setLoading(true)
        /*         btnRef.current.style.display = "none";
         */
        readData(postedData).then(({ data }) => {
            debugger
            setLoading(false)
/*             btnRef.current?.style?.display = "block";
 */            if (data?.result?.v_count[0]?.cnt_total === null) setShowNotData(true)
            setData(data?.result?.v_result)
            calcPages(data?.result?.v_count[0]?.cnt_total);
            setShowItem(true);
            setCount(data.result.v_count[0].cnt_total);


        });
    }

    const submitFilter = () => {
        if(!isEditMode){
            if(!issueDate || !expireDate) return;
        }
        getData({}, filterItems);
        setAdvancedSearch(true);
    }

    const removeFilter = () => {
        setFilterItems({});
        setAdvancedSearch(false);
        setLoading(false);
        setData([]);
        setExpireDate(null)
        setIssueDate(null)
        setShowNotData(false)
        setFilterItems({ p_status: "" })
        setBusinessId(0)


        const postedData = {
            "p_fromdate": convertToDate(getToday()).replaceAll("/", ""),
            "p_todate": convertToDate(getToday()).replaceAll("/", ""),
            "p_card":"",
            "p_mobile": "",
            "p_nationalcode": "",
            "p_status": 0,
            "p_offset": 1,
            "p_limit":  9 ,                                                                                                                                                                                                                                            
            "p_rrn":  "",
            "p_traceno": ""
        }
        setLoading(true)     
        readData(postedData).then(({ data }) => {
            debugger
            setLoading(false)
            if (data?.result?.v_count[0]?.cnt_total === null) setShowNotData(true)
            setData(data?.result?.v_result)
            calcPages(data?.result?.v_count[0]?.cnt_total);
            setShowItem(true);
            setCount(data.result?.v_count[0]?.cnt_total);
        });

    }


    function getToday() {
        const today = moment().format("jYYYY-jMM-jDD").split("-")
        return {
            year: +today[0],
            month: +today[1],
            day: +today[2]
        }
    }

    const calcPages = res => {
        debugger
        let calcPages = res / (pageItems === 0 ? 9 : pageItems);
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page, filteredPostedData = {}) => {
        debugger
        e.preventDefault();
        setShowLoading(true);
        setCurrentPage(page);
        const postedData = {
            "p_limit": (pageItems === 0 ? 10 : pageItems),
            "p_offset": page,
            "p_card": filterItems.p_cardno || "",
            "p_fromdate": (convertToDate(issueDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_todate": (convertToDate(expireDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_businessid": (businesses.length === 1 ? businesses[0].value : (businessId === 0 ? "" : businessId)).toString(),
            "p_mobile": filterItems.p_mobileno || "",
            "p_nationalcode": filterItems.p_nationalno || (searchParams.get('nationalCode') || ''),
            "p_status": parseInt(filterItems?.p_status) || 0,
            "p_rrn": filterItems.p_rrn || "",
            "p_traceno": filterItems.p_traceno || "",
            // "p_companyid": filterItems.p_companyid || ""
        };
        if(filterItems.p_companyid)
            postedData.p_companyid = filterItems.p_companyid;
        if (filterItems.p_channel)
            postedData.p_channel = filterItems.p_channel;
        setLoading(true)
/*         btnRef.current.style.display = "none";
 */        readData(postedData).then(({ data }) => {
            debugger
            setLoading(false)
/*             btnRef.current.style.display = "block";
 */            if (data?.result?.v_result?.length === 0) setShowNotData(true)
            setData(data?.result?.v_result)

        });
    }

    const prevPage = (e, filteredPostedData = {}) => {
        debugger
        setShowLoading(true);
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            "p_limit": (pageItems === 0 ? 10 : pageItems),
            "p_offset": currentPage - 1,
            "p_card": filterItems.p_cardno || "",
            "p_fromdate": (convertToDate(issueDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_todate": (convertToDate(expireDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_businessid": (businesses.length === 1 ? businesses[0].value : (businessId === 0 ? "" : businessId)).toString(),
            "p_mobile": filterItems.p_mobileno || "",
            "p_nationalcode": filterItems.p_nationalno || (searchParams.get('nationalCode') || ''),
            "p_status": parseInt(filterItems?.p_status) || 0,
            "p_rrn": filterItems.p_rrn || "",
            "p_traceno": filterItems.p_traceno || "",
            // "p_companyid": filterItems.p_companyid || ""
        };
        if(filterItems.p_companyid)
            postedData.p_companyid = filterItems.p_companyid;
        if (filterItems.p_channel)
            postedData.p_channel = filterItems.p_channel;
        setLoading(true)
/*         btnRef.current.style.display = "none";
 */        readData(postedData).then(({ data }) => {
            setLoading(false)
/*             btnRef.current.style.display = "block";
 */            if (data?.result?.v_result?.length === 0) setShowNotData(true)
            setData(data?.result?.v_result)

        });
    }

    const nextPage = (e, filteredPostedData = {}) => {
        debugger
        setShowLoading(true);
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            "p_limit": (pageItems === 0 ? 10 : pageItems),
            "p_offset": currentPage + 1,
            "p_card": filterItems.p_cardno || "",
            "p_fromdate": (convertToDate(issueDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_todate": (convertToDate(expireDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_businessid": (businesses.length === 1 ? businesses[0].value : (businessId === 0 ? "" : businessId)).toString(),
            "p_mobile": filterItems.p_mobileno || "",
            "p_nationalcode": filterItems.p_nationalno || (searchParams.get('nationalCode') || ''),
            "p_status": parseInt(filterItems?.p_status) || 0,
            "p_rrn": filterItems.p_rrn || "",
            "p_traceno": filterItems.p_traceno || "",
            // "p_companyid": filterItems.p_companyid || ""
        };
        if(filterItems.p_companyid)
            postedData.p_companyid = filterItems.p_companyid;
        if (filterItems.p_channel)
            postedData.p_channel = filterItems.p_channel;
        setLoading(true)
/*         btnRef.current.style.display = "none";
 */        readData(postedData).then(({ data }) => {
            setLoading(false)
/*             btnRef.current.style.display = "block";
 */            if (data?.result?.v_result?.length === 0) setShowNotData(true)
            setData(data?.result?.v_result)

        });
    }

    const firstPage = (e, filteredPostedData = {}) => {
        setShowLoading(true);
        e.preventDefault();
        setCurrentPage(1);
        const postedData = {
            "p_limit": (pageItems === 0 ? 10 : pageItems),
            "p_offset": 1,
            "p_card": filterItems.p_cardno || "",
            "p_fromdate": (convertToDate(issueDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_todate": (convertToDate(expireDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_businessid": (businesses.length === 1 ? businesses[0].value : (businessId === 0 ? "" : businessId)).toString(),
            "p_mobile": filterItems.p_mobileno || "",
            "p_nationalcode": filterItems.p_nationalno || (searchParams.get('nationalCode') || ''),
            "p_status": parseInt(filterItems?.p_status) || 0,
            "p_rrn": filterItems.p_rrn || "",
            "p_traceno": filterItems.p_traceno || "",
            // "p_companyid": filterItems.p_companyid || ""
        };
        if(filterItems.p_companyid)
            postedData.p_companyid = filterItems.p_companyid;
        if (filterItems.p_channel)
            postedData.p_channel = filterItems.p_channel;
        setLoading(true)
        readData(postedData).then(({ data }) => {
            setLoading(false)
            if (data?.result?.v_result?.length === 0) setShowNotData(true)
            setData(data?.result?.v_result)

        });
    }



    const endPage = (e, filteredPostedData = {}) => {
        setShowLoading(true);
        e.preventDefault();
        setCurrentPage(pages.length);
        const postedData = {
            "p_limit": (pageItems === 0 ? 10 : pageItems),
            "p_offset": pages.length,
            "p_card": filterItems.p_cardno || "",
            "p_fromdate": (convertToDate(issueDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_todate": (convertToDate(expireDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_businessid": (businesses.length === 1 ? businesses[0].value : (businessId === 0 ? "" : businessId)).toString(),
            "p_mobile": filterItems.p_mobileno || "",
            "p_nationalcode": filterItems.p_nationalno || (searchParams.get('nationalCode') || ''),
            "p_status": parseInt(filterItems?.p_status) || 0,
            "p_rrn": filterItems.p_rrn || "",
            "p_traceno": filterItems.p_traceno || "",
            // "p_companyid": filterItems.p_companyid || ""
        };
        if(filterItems.p_companyid)
            postedData.p_companyid = filterItems.p_companyid;
        if (filterItems.p_channel)
            postedData.p_channel = filterItems.p_channel;
        setLoading(true)

        readData(postedData).then(({ data }) => {
            setLoading(false)
            if (data?.result?.v_result?.length === 0) setShowNotData(true)
            setData(data?.result?.v_result)

        });
    }



    const searchData = (traceNo) => {
        const postedData = {
            rrn: traceNo
        };
        getDataServiceConsumer(postedData);
    }

    const downloadExcelExport = () => {
        debugger
        setLoading(true)
        const postedData = {
            "p_limit": 1000,
            "p_offset": 0,
            "p_card": filterItems.p_cardno || "",
            "p_fromdate": (convertToDate(issueDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_todate": (convertToDate(expireDate) || convertToDate(getToday())).replaceAll("/", ""),
            "p_businessid": (businesses.length === 1 ? businesses[0].value : (businessId === 0 ? "" : businessId)).toString(),
            "p_mobile": filterItems.p_mobileno || "",
            "p_nationalcode": filterItems.p_nationalno || "",
            "p_status": parseInt(filterItems?.p_status) || 0,
            "p_rrn": filterItems.p_rrn || "",
            "p_traceno": filterItems.p_traceno || "",
            // "p_companyid": filterItems.p_companyid || ""
        };
        if(filterItems.p_companyid)
            postedData.p_companyid = filterItems.p_companyid;
        if (filterItems.p_channel)
            postedData.p_channel = filterItems.p_channel;
        readData(postedData).then(({ data }) => {
            setLoading(false)
            debugger
            let csvString = 'نام خریدار ,نام دارنده کارت,کد ملی,شماره کارت,مبلغ,نام کسب و کار,تاریخ و ساعت,وضعیت,روش پرداخت,شماره پیگیری,شناسه پرداخت (ارجاع)\r';

            let csvItemString = []

            data?.result?.v_result?.map(item => {
                csvItemString.push({
                    ...item,
                    date: item.trn_date.toString().slice(0, 4) + '-' + item.trn_date.toString().slice(4, 6) + '-' + item.trn_date.toString().slice(6, 8) + ' ' + (item.trn_time || '-')
                })
            })

            csvItemString.map(row => {
                csvString += `${row.child_name ? row.child_name : (row.fullname || '-')},${row?.fullname},${row.nationalcode},${row?.pan_mask},${row?.amount},${row?.business_title},${row?.date},${row?.status_desc},${row?.payment_type},${row?.traceno},${row?.refrenceno}\r`;
            });

            let universalBOM = '\uFEFF';
            let a = window.document.createElement('a');
            a.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csvString));
            let fileName = 'report-export.csv';
            a.setAttribute('download', fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        });

    }



    return (
        <div className="card">
            <div className="card-header"><div className="card-title" >لیست تراکنش ها  </div></div>
            <div className="card-body">

                <div className="row">
                    <div className="col-md-12">
                        {false ? <div className="card-body col-md-12 mt-2 p-2 mx-auto mb-4 pb-2 timeline-panel alert  ">
                            <div className="row mb-4">
                                <div className='mb-4 alert alert-info'>
                                    <b>
                                        <i className="fa fa-info mx-3 text-danger"></i>
                                        جهت مشاهده تراکنش های مورد نظر خود

                                        وارد کردن


                                        <span className='text-danger'> &nbsp;    تاریخ    &nbsp;</span>

                                        و همچنین
                                        <span className='text-danger'>  &nbsp;   شماره کارت &nbsp;</span>

                                        , <span className='text-danger'>&nbsp; الزامی &nbsp;</span>
                                        است.
                                    </b>
                                </div>
                            </div>
                            <hr />
                        </div> : ''}
                        <div className="mb-0 borderRightContact py-3 px-3">
                            <div className="panel panel-body  m-0 p-0 ">
                                <div className="row">
                                    {roleId != 3 ? <div className="col-md-2">
                                        <div className="form-group">
                                            <label>کسب و کار</label>
                                            {businessId ? <i className="fe fe-x clear-select-btn" onClick={e => setBusinessId(0)}></i> : ''}
                                            <ReactSelect
                                                isDisabled={businesses.length === 1 ? true : false}
                                                noOptionsMessage={e => 'یافت نشد'}
                                                placeholder="انتخاب کنید" options={businesses}
                                                value={businesses.length === 1 ? businesses[0] : businesses.filter(b => b.value == businessId)}
                                                onChange={e => setBusinessId(e.value)} />
                                        </div>
                                    </div> : ''}
                                    {roleId != 3 ? <div className="col-md-2">
                                        <div className="form-group">
                                            <label>شرکت زیر مجموعه</label>
                                            {filterItems.p_companyid ? <i className="fe fe-x clear-select-btn" onClick={e => setFilterItems({...filterItems,p_companyid: ''})}></i> : ''}
                                            <ReactSelect
                                                isDisabled={branches.length === 1 ? true : false}
                                                noOptionsMessage={e => 'یافت نشد'}
                                                placeholder="انتخاب کنید" options={branches}
                                                value={branches.length === 1 ? branches[0] : branches.filter(b => b.value == filterItems.p_companyid)}
                                                onChange={e => setFilterItems({...filterItems,p_companyid: e.value})} />
                                        </div>
                                    </div> : ''}
                                    {!isEditMode && <> <div className="col-md-2 deskTopShow" style={{ position: "relative" }}>
                                        <div className="form-group">
                                            <label htmlFor="issueDate"> از تاریخ</label><br />
                                            {issueDate && <i class="fe fe-x clear-select-btn" onClick={() => setIssueDate(null)} style={{left: 25}}></i>}
                                            <DatePicker
                                                name="p_fromdate"
                                                required
                                                locale="fa"
                                                inputClassName={!issueDate ? 'form-control is-invalid' : 'form-control'}
                                                shouldHighlightWeekends
                                                value={issueDate}
                                                onChange={setIssueDate}
                                                className="form-control"
                                                inputPlaceholder=' تاریخ  را انتخاب کنید ...'
                                                minimumDate={fromMinDate}
                                                maximumDate={fromMaxDate}
                                            />
                                        </div>
                                    </div>
                                        <div className="col-md-2" style={{ position: "relative" }}>
                                            <div className="form-group">
                                                <label htmlFor="p_todate"> تا تاریخ     </label><br />
                                                {expireDate && <i class="fe fe-x clear-select-btn" onClick={() => setExpireDate(null)} style={{left: 25}}></i>}
                                                <DatePicker
                                                    name="p_todate"
                                                    required
                                                    locale="fa"
                                                    inputClassName={!expireDate ? 'form-control is-invalid' : 'form-control'}
                                                    shouldHighlightWeekends
                                                    value={expireDate}
                                                    onChange={setExpireDate}
                                                    className="form-control"
                                                    inputPlaceholder='  تاریخ را انتخاب کنید ...'
                                                    minimumDate={toMinDate}
                                                    maximumDate={toMaxDate}
                                                />
                                            </div>
                                        </div></>}

                                    <div className="col-md-2">
                                        <div className="form-group mb-0">
                                            <label>  شماره کارت (6 رقم از سمت راست)

                                            </label>
                                            <InputMask mask="999999"
                                                className="form-control ltr-input"
                                                value={filterItems?.p_cardno || ''}
                                                onChange={e => setFilterItems(oldData => ({ ...oldData, p_cardno: e.target.value }))}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group mb-0">
                                            <label>شماره موبایل</label>
                                            <InputMask mask="0\9999999999"
                                                className="form-control ltr-input"
                                                value={filterItems?.p_mobileno || ''}
                                                onChange={e => setFilterItems(oldData => ({ ...oldData, p_mobileno: e.target.value }))}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group mb-0">
                                            <label>شماره پیگیری</label>
                                            <InputMask mask="999999"
                                                className="form-control ltr-input"
                                                value={filterItems?.p_traceno || ''}
                                                onChange={e => setFilterItems(oldData => ({ ...oldData, p_traceno: e.target.value }))}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group mb-0">
                                            <label>
                                                شناسه پرداخت   (ارجاع)
                                            </label>
                                            <InputMask mask="999999999999"
                                                className="form-control ltr-input"
                                                value={filterItems?.p_rrn || ''}
                                                onChange={e => setFilterItems(oldData => ({ ...oldData, p_rrn: e.target.value }))}
                                            />
                                        </div>
                                    </div>

                                    {roleId != 3 ? <div className="col-md-2">
                                        <div className="form-group mb-0">
                                            <label>  کد ملی </label>
                                            <InputMask mask="9999999999"
                                                className="form-control ltr-input"
                                                value={filterItems?.p_nationalno || ''}
                                                onChange={e => setFilterItems(oldData => ({ ...oldData, p_nationalno: e.target.value }))}
                                            />
                                        </div>
                                    </div> : ''}

                                    {/*           <div className="col-md-2">
                                        <div className="form-group mb-0">
                                            <label>   شماره فاکتور  </label>
                                            <InputMask
                                                className="form-control ltr-input"
                                                value={filterItems?.p_factorno || ''}
                                                onChange={e => setFilterItems(oldData => ({ ...oldData, p_factorno: e.target.value }))}
                                            />
                                        </div>
                                    </div> */}

                                    <div className="col-md-2 ">
                                        <div className="form-group">
                                            <label> وضعیت </label>
                                            <br />
                                            <select
                                                className="form-control"
                                                value={filterItems?.p_status}
                                                onChange={e => setFilterItems(oldData => ({ ...oldData, p_status: e.target.value }))}
                                            >
                                                <option  >انتخاب کنید </option>
                                                <option value="1">موفق</option>
                                                <option value="2">ناموفق   </option>
                                                <option value="3">برگشت خورده</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-2 ">
                                        <div className="form-group">
                                            <label>نوع تراکنش</label>
                                            <br />
                                            <select
                                                className="form-control"
                                                value={filterItems?.p_channel}
                                                onChange={e => setFilterItems(oldData => ({ ...oldData, p_channel: e.target.value || null }))}
                                            >
                                                <option>انتخاب کنید</option>
                                                <option value="5">فروشگاهی</option>
                                                <option value="2">اپلیکیشن موبایلی</option>
                                                <option value="1">وبسایت</option>
                                                <option value="4">اینترنتی</option>
                                                <option value="6">انتقال بین بخشی</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className={`col-md-4 pt-4 mt-4`} >
                                        <div className='d-flex'>
                                            <button className="btn btn-cyan px-4 "

                                                onClick={submitFilter}>
                                                <i class="fa fa-search mx-2"></i>
                                                جستجو
                                            </button>
                                            {advancedSearch &&
                                                <button className="btn btn-danger mx-2 px-4"
                                                    onClick={removeFilter}>
                                                    <i class="mdi mdi-filter-variant mx-1"></i>
                                                    حذف فیلتر
                                                </button>}
                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>

                        {isLoading ?
                            <div style={{ minHeight: "100px" }}>
                                <div className="lds-facebook my-4" >
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div >
                            </div>
                            :
                            <>

                                {data?.length > 0 ? <div className='row mt-2' style={{ padding: "20px 5px", margin: "1% 3% !important" }}>
                                    <h4 class="title current mt-1 d-flex justify-content-between mb-0">
                                        <div> <i className="fa fa-align-justify"></i> لیست  تراکنش ها </div>
                                    </h4>


                                    {data?.map((call, index) => (<div className="col-md-4" key={'call-' + index}>
                                        <div className="card custom-border-1" style={{ background: `${call.f_status_id === 1 ? "#8ee4a5" : (call.f_status_id === 3 ? 'rgb(227, 214, 102)' : "#ff00004d")}` }} >
                                            <p>نام خریدار : {call.child_name ? call.child_name : (call.fullname || '-')}</p>
                                            <p>نام دارنده کارت : {call.fullname || '-'}</p>
                                            <p>شماره کارت : <span dir="ltr">{call.pan_mask || '-'}</span></p>
                                            <p>شماره موبایل : {call.mobile || '-'}</p>
                                            <p>مبلغ : <span >
                                                {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(call.amount)} ریال
                                            </span></p>
                                            <p>تاریخ و ساعت : <span dir="ltr">{moment(`${call.trn_date}`, "jYYYYjMMjDD").format("jYYYY-jMM-jDD") || '-'} {call.trn_time || '-'}</span></p>
                                            <p>شماره پیگیری : <span dir="ltr">{call.traceno || '-'}</span></p>
                                            <p>   شناسه پرداخت (ارجاع): <span dir="ltr">{call.refrenceno || '-'}</span></p>
                                            <p>وضعیت : <span dir="ltr">{call.status_desc || '-'}</span></p>
                                            {/*       <p>نوع تراکنش : <span dir="ltr">{call.transaction_type || '-'}</span></p> */}
                                            <p>روش پرداخت : <span dir="ltr">{call.payment_type || '-'}</span></p>
                                            {false ? <p>کد ملی : <span dir="ltr">{call.nationalcode || '-'}</span></p> : ''}
                                            <p>نام شرکت : <span>{call.company || '-'}</span></p>
                                            <p>نام کسب و کار : <span>{call.business_title || '-'}</span></p>
                                        </div>
                                    </div>))}
                                    <div className='d-flex justify-content-between'>
                                        <p>تعداد کل ردیف ها : {count || 0}</p>
                                        <Pagination
                                            changePage={changePage}
                                            currentPage={currentPage}
                                            pages={pages}
                                            firstPageClick={firstPage}
                                            endPageClick={endPage}
                                            prevPageClick={prevPage}
                                            nextPageClick={nextPage} />
                                        {pages.length > 1 && <div className="form-group d-flex align-items-center  m-0  ">
                                            <label className='mx-2 mt-4' style={{ textWrap: "nowrap" }}>  تعداد نمایش
                                                در صفحه:  </label>
                                            <select className="form-control"
                                                value={pageItems}
                                                onChange={e => setPageItems(e.target.value)}
                                                style={{ width: "25%" }}  >
                                                <option value="9">  9 </option>
                                                <option value="18"> 18 </option>
                                                <option value="48"> 48 </option>
                                                <option value="81">  81 </option>
                                            </select>
                                        </div>}
                                    </div>

                                    <div className='d-flex justify-content-end'>
                                        <button className={'btn btn-success mt-4'} onClick={downloadExcelExport}>دانلود خروجی اکسل</button>
                                    </div>

                                </div>
                                    :
                                    <>

                                    </>
                                }
                            </>
                        }



                    </div >
                </div>
            </div>
        </div>
    )

}


export default Index;
